import Vue from 'www/vue_components'
import I18NextVue from 'i18next-vue'
import vuetify from 'www/modules/vuetify-plugin'
import YandexGoals from 'www/modules/YandexGoals'
import { initI18n, dispatchCustomEventGlobally } from 'www/utils'
import VideoCard from 'www/vue_components/common/VideoCardLpu/VideoCard.vue'
import initTooltips from 'www/doctors.blocks/common/tippy-tooltip/tippy-tooltip'
import './video-card-lpu.scss'

// @ts-ignore
const mountElements: Array<HTMLDivElement> = [...document.querySelectorAll<HTMLDivElement>('.video-card-vue')]

const init = async () => {
  if (document.querySelector('.js-lpu-video-card-icon')) {
    const yaGoals = new YandexGoals()

    window.addEventListener('click', ({ target }) => {
      if (target && (target as HTMLElement).closest('.js-lpu-video-card-icon')) {
        yaGoals.send({ name: 'common_LpuList_VideoCard__clickRedirect' })
      }
    })
  }

  if (mountElements.length) {
    const { i18next } = await initI18n({ bundle: 'vue_components/common/VideoCardLpu' })

    Vue.use(I18NextVue, { i18next })

    mountElements.forEach((node, id) => {
      const VueInstance = new Vue({
        vuetify,
        name: `VideoCardLpuRoot_${id}`,
        components: { VideoCard },
      })

      VueInstance.$mount(node)
    })

    document.addEventListener('click', event => {
      try {
        if (!event.target) {
          return
        }

        const desktopButton = (event.target as HTMLElement).closest('.b-doctor-details__video-play')
        const mobileButton = (event.target as HTMLElement).closest('.b-doctor-info-card__video-play')

        if (desktopButton || mobileButton) {
          dispatchCustomEventGlobally('click-video-preview-image')
        }
      } catch {} // eslint-disable-line
    })

    if (!window.MOBILE_VERSION) {
      initTooltips()
    }
  }
}

init()
